import { AUTH_MESSAGES, authFailure, sharedAuthMessage } from '../../api';

/** What the verification screens tell the player. */
export const VERIFICATION_MESSAGES = {
  deadline: 'Verify within 30 days or your account will be removed.',
  sent: 'Email sent. Check your inbox, and your spam folder.',
  sendFailed: "We couldn't send the email. Try again in a few minutes.",
  notSent: "We couldn't send your verification email. Use Resend email to try again.",
  stillUnverified: "Your email isn't verified yet. Open the link we sent you, then try again.",
  checkFailed: "We couldn't check your email. Try again in a moment.",
  tooManyRequests: AUTH_MESSAGES.tooManyRequests,
  network: AUTH_MESSAGES.network,
} as const;

/** The alert for a failed call: too many requests and network failures have their own message, all else `fallback`. */
export const verificationErrorMessage = (error: unknown, fallback: string): string =>
  sharedAuthMessage(authFailure(error)) ?? fallback;

/** What resending the verification email logs and announces (useResend). */
export const VERIFICATION_RESEND_MESSAGES = {
  failedLog: 'Resending the verification email failed',
  sent: VERIFICATION_MESSAGES.sent,
  failed: VERIFICATION_MESSAGES.sendFailed,
} as const;
